import { render, staticRenderFns } from "./addExpress.vue?vue&type=template&id=538c4bfa&scoped=true&"
import script from "./addExpress.vue?vue&type=script&lang=js&"
export * from "./addExpress.vue?vue&type=script&lang=js&"
import style0 from "./addExpress.vue?vue&type=style&index=0&id=538c4bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538c4bfa",
  null
  
)

export default component.exports